//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AssetEquipmentRepairDrawer from "./modules/AssetEquipmentRepairDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'AssetEquipmentRepairList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    AssetEquipmentRepairDrawer: AssetEquipmentRepairDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/repair',
      pageTitle: '仪器检修',
      addDisabled: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        dataIndex: 'assetName',
        colName: 'asset_id',
        title: '仪器名称',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'modelNum',
        colName: 'model_num',
        title: '仪器型号',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'failureTime',
        colName: 'failure_time',
        title: '发生时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'cause_dictText',
        colName: 'cause',
        title: '原因',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'faultLevel_dictText',
        colName: 'faultLevel',
        title: '故障等级',
        align: 'center',
        sorter: false
      }, // {
      //     dataIndex: 'description',
      //     colName: 'description',
      //     title: '检修情况说明',
      //     align: "center",
      //     sorter: false
      // },
      // {
      //     dataIndex: 'solution',
      //     colName: 'solution',
      //     title: '解决办法',
      //     align: "center",
      //     sorter: false
      // },
      // {
      //     dataIndex: 'replaceSituation',
      //     colName: 'replace_situation',
      //     title: '部件更换情况',
      //     align: "center",
      //     sorter: false
      // },
      {
        dataIndex: 'calibrationTime',
        colName: 'calibration_time',
        title: '使用前校准时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'calibrationRes_dictText',
        colName: 'calibration_res',
        title: '校准结果是否合格',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'checkRes_dictText',
        colName: 'check_res',
        title: '核查结果是否合格',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'normalTime',
        colName: 'normal_time',
        title: '投入使用时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '维护人员',
        align: 'center',
        sorter: false
      }, // {
      //     dataIndex: 'remark',
      //     colName: 'remark',
      //     title: '备注',
      //     align: "center",
      //     sorter: false
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      userTree: [],
      siteAssetList: [],
      url: {
        querySiteAsset: '/ea/asset/info/queryBySiteId/'
      }
    };
  },
  created: function created() {
    this.loadTreeList();
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
        this.loadSiteAsset();
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    //获取站点仪器设备
    loadSiteAsset: function loadSiteAsset() {
      var that = this;
      that.siteAssetList = [];
      getAction(that.url.querySiteAsset + that.queryParam.siteId).then(function (res) {
        if (res.success) {
          console.log('siteAssetList', res.result);
          that.siteAssetList = res.result;
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateFailureTime: function onDateFailureTime(value, dateArray) {
      this.queryParam.failureTimeStart = dateArray[0];
      this.queryParam.failureTimeEnd = dateArray[1];
    },
    onDateCalibrationTime: function onDateCalibrationTime(value, dateArray) {
      this.queryParam.calibrationTimeStart = dateArray[0];
      this.queryParam.calibrationTimeEnd = dateArray[1];
    },
    onDateNormalTime: function onDateNormalTime(value, dateArray) {
      this.queryParam.normalTimeStart = dateArray[0];
      this.queryParam.normalTimeEnd = dateArray[1];
    }
  }
};